import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';

const getJobStatusBadge = (status) => {
  const variants = {
    created: 'secondary',
    paid: 'default',
    printing: 'default',
    completed: 'default',
    failed: 'destructive'
  };

  return (
    <Badge variant={variants[status] || 'secondary'} className="capitalize">
      {status}
    </Badge>
  );
};

const formatDate = (dateString) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleString();
};

const JobsTable = ({ printJobs }) => {
  return (
    <Card data-testid="jobs-section">
      <CardHeader>
        <CardTitle className="font-heading text-xl">Recent Print Jobs</CardTitle>
        <CardDescription>Latest print jobs across all kiosks</CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Job ID</TableHead>
              <TableHead>Document</TableHead>
              <TableHead>Customer</TableHead>
              <TableHead>Pages</TableHead>
              <TableHead>Cost</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Created</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {printJobs.slice(0, 10).map((job) => (
              <TableRow key={job.id} data-testid={`job-${job.id}`}>
                <TableCell className="font-mono text-sm">
                  {job.id.slice(0, 8)}
                </TableCell>
                <TableCell className="max-w-32 truncate">
                  {job.document_name}
                </TableCell>
                <TableCell>
                  {job.customer_name || '-'}
                </TableCell>
                <TableCell>{job.total_pages}</TableCell>
                <TableCell className="font-medium">₹{job.cost}</TableCell>
                <TableCell>{getJobStatusBadge(job.status)}</TableCell>
                <TableCell className="text-sm text-muted-foreground">
                  {formatDate(job.created_at)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        
        {printJobs.length === 0 && (
          <div className="text-center py-8 text-muted-foreground">
            No print jobs yet
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default JobsTable;
